(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('newsletter-consent')) {
    customElements.define('newsletter-consent', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        this.querySelectorAll('form').forEach((form) => {
          const checkbox = form.querySelector('.newsletter__consent-checkbox');
          const button = form.querySelector('button[type="submit"]');
          if (!checkbox || !button) return;

          const sync = () => { button.disabled = !checkbox.checked; };
          const resetConsent = () => { checkbox.checked = false; sync(); };
          resetConsent();
          checkbox.addEventListener('change', sync, options);
          form.addEventListener('submit', (event) => {
            if (!checkbox.checked) {
              event.preventDefault();
              checkbox.reportValidity();
              sync();
            }
          }, options);
          form.addEventListener('reset', () => queueMicrotask(resetConsent), options);
          window.addEventListener('pageshow', resetConsent, options);
        });
      }

      disconnectedCallback() {
        this.controller.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
